import { takeLatest, put, call } from "redux-saga/effects";
import { sagaActions } from "../../actions";
import {
  fetchWorkflowConfiguration,
  fetchWorkflowConfigurationCompleted,
} from "../../slices/workflow_configuration";
import { workflowsService } from "../../../../../src/core/workflows/workflows_service";

async function handleFetchWorkflowConfiguration({ token = "", page, items }) {
  return await workflowsService.adminListWorkflowConfigurations(page, items);
}

function* listWorkflowConfigurationSaga({ payload }) {
  try {
    yield put(fetchWorkflowConfiguration());
    const workflowConfigurationData = yield call(
      handleFetchWorkflowConfiguration,
      payload
    );
    yield put(fetchWorkflowConfigurationCompleted(workflowConfigurationData));
  } catch (error) {
    console.error(error.message);
  }
}

export function* listWorkflowConfigurationWatcherSaga() {
  yield takeLatest(
    sagaActions.START_FETCH_LIST_WORKFLOW_CONFIGURATION,
    listWorkflowConfigurationSaga
  );
}
